import { makeStyles } from '@mui/styles';

import { colors } from './ui-kit/theme';

export const AppStyles = makeStyles<{}>({
  root: {
    backgroundColor: colors.softPeach,
  },
});
